import Vue from 'vue';
import { monitor, MonitorEvent } from '@/services/monitor';
import { buildEmmet, getParentElement } from '@/utils/buildEmmet';
import { isEnableClickLog } from '@/utils/experiment';

/**
 * 全局点击事件监控插件
 */
const GlobalTrackingPlugin = {
  install(Vue: any) {
    // 添加全局点击监听
    if (isEnableClickLog()) {
      document.addEventListener('click', handleClick, true);
    }

    // 在Vue实例销毁时移除事件监听
    Vue.mixin({
      beforeDestroy() {
        // 只在根Vue实例销毁时移除监听器
        if (this.$root === this) {
          isEnableClickLog() && document.removeEventListener('click', handleClick, true);
        }
      }
    });
  }
};

/**
 * 处理点击事件
 * @param event 点击事件对象
 */
function handleClick(event: MouseEvent) {
  const target = event.target as HTMLElement;

  // 获取元素边界矩形
  const bcr = target.getBoundingClientRect();
  const { width, height } = bcr;

  // 检查是否是需要埋点的元素
  if ((width > 0 && width < 300 && height > 0 && height < 300) || target.getAttribute('data-track')) {
    const parent = getParentElement(target);
    const trackingData = {
      element: buildEmmet(target),
      area: parent !== target ? buildEmmet(parent) : '',
      extra: target.getAttribute('data-track'),
      bcr,
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    };

    monitor({
      event: MonitorEvent.Click,
      data: trackingData
    });
  }
}

export default GlobalTrackingPlugin;
